require('es6-promise').polyfill()
import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)

// load global methods from external files
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

const localStorageValue = localStorage.getItem('user')
let userValue = {}
if(localStorageValue){
  userValue = JSON.parse(window.atob(localStorage.getItem('user')))
}
const user = userValue


const message = {
  info: '',
  msg: '',
  errors: []
}


const loaders = {
  a: false,
  b: false,
  c: false
}

const store =  new Vuex.Store({
  state: {
    user,
    message,
    loaders,
  },
  actions,
  getters,
  mutations,
  modules: {
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js